module.exports = __webpack_public_path__ + "img/companylogo7.32bbd906.png";